import { Dispatch } from 'redux';
import headersBuilder, { Method } from '../../../utils/request';
import setLoadingStatus, { setLoadingStatusInvestorsFetch } from '../setLoadingStatus';
import Errors from '../../../shared/validation/errors';
import { Investor } from '../../../types/investorTypes';
import { updateAccountOptions } from '../../../utils/updateAccountOptions';

export const FETCH_INVESTOR_DETAILS = 'FETCH_INVESTORS_DETAILS ';
export const FETCH_INVESTOR_DETAILS_FALSE = 'FETCH_INVESTOR_DETAILS_FALSE ';
export const FETCH_INVESTOR_DETAILS_ATTACH_DETACH = 'FETCH_INVESTOR_DETAILS_ATTACH_DETACH';

export type FetchInvestorDetailsAction = {
  type: string;
  investorDetails: Investor;
};

export const fetchInvestorDetailsFalse = (investor: Investor): FetchInvestorDetailsAction => {
  return {
    type: FETCH_INVESTOR_DETAILS_FALSE,
    investorDetails: investor
  };
};

export const fetchInvestorDetails = (investor: Investor): FetchInvestorDetailsAction => {
  return {
    type: FETCH_INVESTOR_DETAILS,
    investorDetails: investor
  };
};

export const fetchInvestorDetailsAttachDetach = (investor: Investor): FetchInvestorDetailsAction => {
  return {
    type: FETCH_INVESTOR_DETAILS_ATTACH_DETACH,
    investorDetails: investor
  };
};

export function fetchInvestorDetailsFalseAsync(api: string, investorId: number) {
  return (dispatch: Dispatch): void => {
    dispatch(setLoadingStatus(true));
    dispatch(setLoadingStatusInvestorsFetch(true));

    fetch(`${api}/investors/${investorId}?returnAccountOptionsValue=false`, headersBuilder(Method.GET))
      .then((response: Response) => Errors.checkResponseForErrors(response, api))
      .then((investor: any) => dispatch(fetchInvestorDetailsFalse(investor)))
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      .then(() => dispatch<any>(fetchInvestorDetailsAsync(api, Number(investorId))))
      .catch((error: Error) => Errors.throwErrorMessage(error))
      .finally(() => {
        dispatch(setLoadingStatus(false));
        dispatch(setLoadingStatusInvestorsFetch(false));
      });
  };
}

function fetchInvestorDetailsAsync(api: string, investorId: number, admin?: boolean) {
  return (dispatch: Dispatch): void => {
    dispatch(setLoadingStatus(true));
    dispatch(setLoadingStatusInvestorsFetch(true));

    fetch(`${api}/investors/${investorId}?returnAccountOptionsValue=${!admin}`, headersBuilder(Method.GET))
      .then((response: Response) => Errors.checkResponseForErrors(response, api))
      .then((investor: any) => {
        updateAccountOptions(investor);
        dispatch(fetchInvestorDetails(investor));
      })
      .catch((error: Error) => {
        Errors.throwErrorMessage(error);
      })
      .finally(() => {
        dispatch(setLoadingStatus(false));
        dispatch(setLoadingStatusInvestorsFetch(false));
      });
  };
}

export function fetchInvestorDetailsAttachDetachAsync(api: string, investorId: number, admin?: boolean) {
  return (dispatch: Dispatch): void => {
    dispatch(setLoadingStatus(true));
    dispatch(setLoadingStatusInvestorsFetch(true));

    fetch(`${api}/investors/${investorId}?returnAccountOptionsValue=${!admin}`, headersBuilder(Method.GET))
      .then((response: Response) => Errors.checkResponseForErrors(response, api))
      .then((investor: any) => dispatch(fetchInvestorDetailsAttachDetach(investor)))
      .catch((error: Error) => Errors.throwErrorMessage(error))
      .finally(() => {
        dispatch(setLoadingStatus(false));
        dispatch(setLoadingStatusInvestorsFetch(false));
      });
  };
}

export default fetchInvestorDetailsAsync;
